module.exports = __webpack_public_path__ + "icons/original/large/large-e6.60a05543c24485dc78b1cb4f47c306be.png";


//////////////////
// WEBPACK FOOTER
// ./src/web/icons/original/large/large-e6.png
// module id = YFuY
// module chunks = app